<template>

    <div class="progress-monitor-step-3">

        <b-form-group label="Enter the START date for this intervention:">
            <b-form-input type="date" required
                          v-model="docData.startDate"/>
        </b-form-group>
        <b-form-group label="Enter the END date for this intervention:">
            <b-form-input type="date" required
                          v-model="docData.endDate"/>
        </b-form-group>

    </div>

</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'

    export default Vue.extend({
        name: "ProgressMonitorStep3",
        mixins: [ToolMixin],
        computed: {
            thisStepIsValid() {
                return this.docData.startDate
                    && this.docData.endDate
            }
        },
    })

</script>


